export default __webpack_public_path__ + "static/media/Super-Chrome-Extension-Manual.f37e2e68.docx";